import { serviceUrl } from '../config/net.config'
import request from '@/utils/request'
/**
 * 根据字典取数据
 * @param {*} params 
 * @returns 
 */
export function getSysDict(params) {
    return request({
      url: '/base/getSysDict?dictTypeCode=' + params,
      method: 'get',
    })
  }

  export function save(data) {
    return request({
      url: serviceUrl+'/api/wtbuCopyService/save',
      head: 'application/json;charset=UTF-8',
      method: 'post',
      data,
      token:sessionStorage.getItem('xzztcToken')
    })
  }
  export function copyServiceUpdatehandlestate(data) {
    return request({
      url: serviceUrl+'/api/wtbuCopyService/updatehandlestate',
      head: 'application/json;charset=UTF-8',
      method: 'post',
      data,
      token:sessionStorage.getItem('xzztcToken')
    })
  }

  export function findCopyServiceInfoById(params) {
    return request({
      url: serviceUrl+'/api/wtbuCopyService/findCopyServiceInfoById?id='+params,
      head: 'application/json;charset=UTF-8',
      method: 'get',
      token:sessionStorage.getItem('xzztcToken')
    })
  }